module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/deptenquirydetails/deptenquirydetails-form/deptenquirydetails-form.component.css
// module id = ./src/app/hrms/serviceregister/deptenquirydetails/deptenquirydetails-form/deptenquirydetails-form.component.css
// module chunks = main